(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["base-media-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var NAV_VAR = '--base-nav-h';
  var ANNOUNCE_VAR = '--base-announce-h';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var ICON_PLAY  = '<svg viewBox="0 0 20 20" width="18" height="18" focusable="false"><polygon points="5,3 17,10 5,17" fill="currentColor"/></svg>';
  var ICON_PAUSE = '<svg viewBox="0 0 20 20" width="18" height="18" focusable="false"><rect x="4" y="3" width="4" height="14" fill="currentColor"/><rect x="12" y="3" width="4" height="14" fill="currentColor"/></svg>';

  /* ---------- header + announcement heights, resolved for every base- section ---------- */
  function firstMatch(selector) {
    if (!selector) return null;
    var parts = selector.split(',');
    for (var i = 0; i < parts.length; i++) {
      var el = document.querySelector(parts[i].trim());
      if (el) return el;
    }
    return null;
  }

  function heightOf(el) {
    return el ? Math.round(el.getBoundingClientRect().height) : 0;
  }

  var announceEl = null;
  var announceRO = null;

  function measureChrome() {
    var host = document.querySelector('[data-base-nav-selector]');
    if (!host) return;

    var nav = firstMatch(host.getAttribute('data-base-nav-selector'));
    document.documentElement.style.setProperty(NAV_VAR, heightOf(nav) + 'px');

    var next = firstMatch(host.getAttribute('data-base-announce-selector'));
    document.documentElement.style.setProperty(ANNOUNCE_VAR, heightOf(next) + 'px');

    /* The bar is dismissible, so watch it and re-measure when it collapses. */
    if (next !== announceEl) {
      if (announceRO) announceRO.disconnect();
      announceEl = next;
      if (announceEl && 'ResizeObserver' in window) {
        announceRO = new ResizeObserver(function () {
          document.documentElement.style.setProperty(ANNOUNCE_VAR, heightOf(announceEl) + 'px');
          measureOffsets();
        });
        announceRO.observe(announceEl);
      }
    }
  }

  /* Distance from the top of the document to each banner. Whatever sits above it
     — announcement bar, header, anything added later — is included automatically. */
  function measureOffsets() {
    var wrappers = document.querySelectorAll('[data-base-nav-selector]');
    Array.prototype.forEach.call(wrappers, function (w) {
      var top = Math.round(w.getBoundingClientRect().top + (window.pageYOffset || 0));
      if (top < 0) top = 0;
      w.style.setProperty('--base-banner-offset', top + 'px');
    });
  }

  /* Publish each aside band's height so centred content can offset
     against it. Observed rather than measured once, because the band
     grows when copy wraps or the viewport narrows. */
  var asideROs = [];
  function measureAsides() {
    var wrappers = document.querySelectorAll('[data-base-nav-selector]');
    Array.prototype.forEach.call(wrappers, function (w) {
      var aside = w.querySelector('.base-banner__aside');
      if (!aside) return;

      var apply = function () {
        /* Collapse first, then measure — a hidden band must report 0
           so no optical-centring padding is added for it. */
        var items = aside.querySelectorAll('.base-banner__aside-item');
        var visible = 0;
        Array.prototype.forEach.call(items, function (el) {
          if (getComputedStyle(el).display !== 'none') visible++;
        });
        aside.classList.toggle('is-empty', visible === 0);

        var h = aside.classList.contains('is-empty')
          ? 0
          : Math.round(aside.getBoundingClientRect().height);
        w.style.setProperty('--base-aside-h', h + 'px');
      };
      apply();

      if (!aside.dataset.baseAsideObserved && 'ResizeObserver' in window) {
        aside.dataset.baseAsideObserved = 'true';
        var ro = new ResizeObserver(apply);
        ro.observe(aside);
        asideROs.push(ro);
      }
    });
  }

  var navTimer;
  function measureNavDebounced() {
    clearTimeout(navTimer);
    navTimer = setTimeout(function () { measureChrome(); measureOffsets(); measureAsides(); }, 120);
  }

  /* ---------- one banner instance ---------- */
  function BaseBanner(root) {
    this.root = root;
    this.video = root.querySelector('[data-base-banner-video]');
    this.toggle = root.querySelector('[data-base-banner-toggle]');
    this.icon = root.querySelector('[data-base-banner-toggle-icon]');
    this.userPaused = false;
    this.loaded = false;

    if (!this.video || !this.toggle) return;

    this.onToggle = this.handleToggle.bind(this);
    this.toggle.addEventListener('click', this.onToggle);

    this.video.addEventListener('playing', this.setPlayingUI.bind(this));
    this.video.addEventListener('pause', this.setPausedUI.bind(this));

    /* iOS does not reliably fire loadeddata before playback starts when
       preload is none, so reveal on whichever of these lands first —
       otherwise the video plays behind an opacity:0 layer. */
    var reveal = function () { this.video.classList.add('is-visible'); }.bind(this);
    ['loadedmetadata', 'loadeddata', 'canplay', 'playing'].forEach(function (evt) {
      this.video.addEventListener(evt, reveal);
    }.bind(this));

    /* Reduced motion: leave the poster image in place, wait for an explicit play. */
    if (reduceMotion.matches) {
      this.userPaused = true;
      this.setPausedUI();
    } else {
      this.load();
      this.play();
    }

    this.observe();
  }

  /* Pick a single source. Never attach both — that is what double-downloads. */
  BaseBanner.prototype.load = function () {
    if (this.loaded) return;
    var isDesktop = window.matchMedia('(min-width: 750px)').matches;
    var d = this.video.getAttribute('data-src-desktop');
    var m = this.video.getAttribute('data-src-mobile');
    var src = isDesktop ? (d || m) : (m || d);
    if (!src) return;
    this.video.setAttribute('src', src);
    this.loaded = true;
  };

  BaseBanner.prototype.play = function () {
    this.load();

    /* Safari gates autoplay on the muted PROPERTY, which the HTML
       attribute does not always set in time. Assert it every play. */
    this.video.muted = true;
    this.video.defaultMuted = true;
    this.video.setAttribute('muted', '');

    var p = this.video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function (err) {
        if (window.console && console.warn) {
          console.warn('[base-banner] autoplay blocked:', err && err.name, err && err.message);
        }
        this.setPausedUI();
      }.bind(this));
    }
  };

  BaseBanner.prototype.handleToggle = function () {
    if (this.video.paused) {
      this.userPaused = false;
      this.play();
    } else {
      this.userPaused = true;
      this.video.pause();
    }
  };

  BaseBanner.prototype.setPlayingUI = function () {
    this.icon.innerHTML = ICON_PAUSE;
    this.toggle.setAttribute('aria-label', this.toggle.getAttribute('data-label-pause'));
  };

  BaseBanner.prototype.setPausedUI = function () {
    this.icon.innerHTML = ICON_PLAY;
    this.toggle.setAttribute('aria-label', this.toggle.getAttribute('data-label-play'));
  };

  /* Stop decoding video that nobody can see. */
  BaseBanner.prototype.observe = function () {
    if (!('IntersectionObserver' in window)) return;
    this.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (!this.userPaused && this.video.paused) this.play();
        } else if (!this.video.paused) {
          this.video.pause();
        }
      }.bind(this));
    }.bind(this), { threshold: 0.1 });
    this.io.observe(this.root);
  };

  BaseBanner.prototype.destroy = function () {
    if (this.io) this.io.disconnect();
    if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
    if (this.video) {
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
    }
  };

  /* ---------- boot ---------- */
  var instances = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-base-banner]');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.dataset.baseBannerReady) return;
      el.dataset.baseBannerReady = 'true';
      var b = new BaseBanner(el);
      if (instances) instances.set(el, b);
    });
    measureChrome();
    measureOffsets();
    measureAsides();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  window.addEventListener('resize', measureNavDebounced);
  window.addEventListener('orientationchange', measureNavDebounced);

  /* Theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('[data-base-banner]');
    if (el && instances && instances.has(el)) instances.get(el).destroy();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  /* ------------------------------------------------------------------
     Generic mobile toggler. Now used only by link-list items whose URL is
     '#'. The footer block headers have their own controller below.
     Guarded against duplicate binding, since this re-runs on every
     breakpoint crossing.
     ------------------------------------------------------------------ */
  function mobileToggler(x) {
    if (x.matches) {
      document.querySelectorAll('.mobile-toggler').forEach(item => {
        if (item.dataset.togglerBound) return;
        item.dataset.togglerBound = '1';
        item.addEventListener('click', (event) => {
          event.preventDefault();
          let toggler = event.currentTarget.classList;
          toggler.contains('toggled') ? toggler.remove('toggled') : toggler.add('toggled');
        });
      });
    }
  }
  var x = window.matchMedia("(max-width: 991px)")
  mobileToggler(x);
  x.addListener(mobileToggler);

  /* ------------------------------------------------------------------
     Footer accordion controller.

     Mobile (<=991px): each <button> toggles .is-open on its .footer-block
     and keeps aria-expanded in sync.
     Desktop (>=992px): panels are always visible, so the buttons are
     disabled — inert and out of the tab order — and aria-expanded is
     removed so nothing announces a collapsed state that doesn't exist.
     ------------------------------------------------------------------ */
  (function () {
    var mq = window.matchMedia('(max-width: 991px)');

    function setOpen(btn, open) {
      var block = btn.closest('.footer-block');
      if (!block) return;
      block.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function onClick(event) {
      var btn = event.currentTarget;
      setOpen(btn, btn.getAttribute('aria-expanded') !== 'true');
    }

    function sync() {
      document.querySelectorAll('.footer-block__toggle-btn').forEach(function (btn) {
        if (!btn.dataset.accordionBound) {
          btn.dataset.accordionBound = '1';
          btn.addEventListener('click', onClick);
        }

        var block = btn.closest('.footer-block');

        if (mq.matches) {
          btn.disabled = false;
          setOpen(btn, btn.getAttribute('aria-expanded') === 'true');
        } else {
          btn.disabled = true;
          btn.removeAttribute('aria-expanded');
          if (block) block.classList.remove('is-open');
        }
      });
    }

    function init() {
      sync();
      if (mq.addEventListener) {
        mq.addEventListener('change', sync);
      } else {
        mq.addListener(sync);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Theme editor re-renders the section without re-running this file
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector('.footer-block__toggle-btn')) {
        sync();
      }
    });
  })();

    document.addEventListener('DOMContentLoaded', function() {
    // Select all footer blocks with the menu class
    const footerBlocks = document.querySelectorAll('.footer-block--menu');
    
    // Loop through each block and add a number
    footerBlocks.forEach(function(block, index) {
      // Add the number (starting from 1)
      block.classList.add('footer-block--menu-' + (index + 1));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionid = 'shopify-section-' + this.getAttribute('data-section-id');
      this.header = document.getElementById(this.sectionid);
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.predictiveSearch = this.querySelector('predictive-search');
      
      // Set up announcement bar height CSS variable
      this.setAnnouncementBarHeight();
      
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      
      // Update announcement bar height on resize
      window.addEventListener('resize', () => {
        this.setAnnouncementBarHeight();
      }, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    setAnnouncementBarHeight() {
      // Find announcement bar and set CSS variable
      const announcementBar = document.querySelector('.shopify-section-announcement-bar, .announcement-bar, [data-section-type="announcement-bar"]');
      const height = announcementBar ? announcementBar.offsetHeight + 'px' : '0px';
      document.documentElement.style.setProperty('--announcement-bar-height', height);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.makeSticky.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    makeSticky() {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-caption"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('image-caption-video')) {
  class ImageCaptionVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-video-toggle]');
      if (!this.video) return;

      this.video.setAttribute('playsinline', '');
      this.video.setAttribute('muted', '');
      this.video.muted = true;

      if (!this.button) return;

      this.onToggle = this.toggle.bind(this);
      this.onPlay = this.sync.bind(this, true);
      this.onPause = this.sync.bind(this, false);

      this.button.addEventListener('click', this.onToggle);
      this.video.addEventListener('play', this.onPlay);
      this.video.addEventListener('pause', this.onPause);
      this.sync(!this.video.paused);
    }

    disconnectedCallback() {
      if (!this.video || !this.button) return;
      this.button.removeEventListener('click', this.onToggle);
      this.video.removeEventListener('play', this.onPlay);
      this.video.removeEventListener('pause', this.onPause);
    }

    toggle() {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    }

    sync(playing) {
      this.classList.toggle('is-paused', !playing);
      this.button.setAttribute('aria-pressed', playing ? 'true' : 'false');
      this.button.setAttribute(
        'aria-label',
        playing ? this.dataset.pauseLabel : this.dataset.playLabel
      );
    }
  }

  customElements.define('image-caption-video', ImageCaptionVideo);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-2026"]) return;
  try {
    
    const productSection = document.querySelector('[id^="ProductInfo-"]');
    const stickyData = productSection?.dataset.sticky;
    if (stickyData === 'true') {
      var sidebarEl = document.querySelector('.sidebar__inner');
      var sidebar = new StickySidebar(sidebarEl, {
        topSpacing: 40,
        containerSelector: '.product__info-wrapper',
        innerWrapperSelector: '.sidebar__inner-padding',
        resizeSensor: true,
        minWidth: 992,
      });
      sidebarEl.addEventListener('affix.bottom.stickySidebar', function (event) {});
    }
    class Accordion {
      constructor(el) {
        this.el = el;
        this.summary = el.querySelector('summary');
        this.content = el.querySelector('.accordion__content');
  
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.summary.addEventListener('click', (e) => this.onClick(e));
      }
  
      onClick(e) {
        e.preventDefault();
        this.el.style.overflow = 'hidden';
        
        // Update aria-expanded
        const isOpen = this.el.open;
        this.summary.setAttribute('aria-expanded', !isOpen);
        
        if (this.isClosing || !this.el.open) {
          this.open();
        } else if (this.isExpanding || this.el.open) {
          this.shrink();
        }
      }
  
      shrink() {
        this.isClosing = true;
  
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;
  
        if (this.animation) {
          this.animation.cancel();
        }
  
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 400,
            easing: 'ease-out',
          }
        );
  
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => (this.isClosing = false);
      }
  
      open() {
        this.el.style.height = `${this.el.offsetHeight}px`;
        this.el.open = true;
        window.requestAnimationFrame(() => this.expand());
      }
  
      expand() {
        this.isExpanding = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
  
        if (this.animation) {
          this.animation.cancel();
        }
  
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 400,
            easing: 'ease-out',
          }
        );
        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => (this.isExpanding = false);
      }
  
      onAnimationFinish(open) {
        this.el.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.el.style.height = this.el.style.overflow = '';
        if (stickyData === 'true') {
          sidebar.updateSticky();
        }
      }
    }
  
    document.querySelectorAll('details.accordion__details').forEach((el) => {
      new Accordion(el);
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    const productSection = document.querySelector('[id^="ProductInfo-"]');
    const stickyData = productSection?.dataset.sticky;
    if (stickyData === 'true') {
      var sidebarEl = document.querySelector('.sidebar__inner');
      var sidebar = new StickySidebar(sidebarEl, {
        topSpacing: 40,
        containerSelector: '.product__info-wrapper',
        innerWrapperSelector: '.sidebar__inner-padding',
        resizeSensor: true,
        minWidth: 992,
      });
      sidebarEl.addEventListener('affix.bottom.stickySidebar', function (event) {});
    }
    class Accordion {
      constructor(el) {
        this.el = el;
        this.summary = el.querySelector('summary');
        this.content = el.querySelector('.accordion__content');
  
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.summary.addEventListener('click', (e) => this.onClick(e));
      }
  
      onClick(e) {
        e.preventDefault();
        this.el.style.overflow = 'hidden';
        
        // Update aria-expanded
        const isOpen = this.el.open;
        this.summary.setAttribute('aria-expanded', !isOpen);
        
        if (this.isClosing || !this.el.open) {
          this.open();
        } else if (this.isExpanding || this.el.open) {
          this.shrink();
        }
      }
  
      shrink() {
        this.isClosing = true;
  
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;
  
        if (this.animation) {
          this.animation.cancel();
        }
  
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 400,
            easing: 'ease-out',
          }
        );
  
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => (this.isClosing = false);
      }
  
      open() {
        this.el.style.height = `${this.el.offsetHeight}px`;
        this.el.open = true;
        window.requestAnimationFrame(() => this.expand());
      }
  
      expand() {
        this.isExpanding = true;
        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
  
        if (this.animation) {
          this.animation.cancel();
        }
  
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 400,
            easing: 'ease-out',
          }
        );
        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => (this.isExpanding = false);
      }
  
      onAnimationFinish(open) {
        this.el.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.el.style.height = this.el.style.overflow = '';
        if (stickyData === 'true') {
          sidebar.updateSticky();
        }
      }
    }
  
    document.querySelectorAll('details.accordion__details').forEach((el) => {
      new Accordion(el);
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-template--about-image-text"]) return;
  try {
    
  var controller = new ScrollMagic.Controller();
  $('.year').each(function() {
    new ScrollMagic.Scene({triggerElement: this})
        .setClassToggle(this, "active")
        .addTo(controller);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-template--about"] && !Shopify.designMode) return;
  try {
    
  var controller = new ScrollMagic.Controller();
  $('.year').each(function() {
    new ScrollMagic.Scene({triggerElement: this})
        .setClassToggle(this, "active")
        .addTo(controller);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-page-proprogram"]) return;
  try {
    
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
      open ? this.el.closest('.page-width').classList.add('accordion-open') : this.el.closest('.page-width').classList.remove('accordion-open');
    }
  }

  document.querySelectorAll('details.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();
})();
